__turbopack_context__.v({
  "background": "starfield-background-module-scss-module__KawuOa__background",
  "background-animation": "starfield-background-module-scss-module__KawuOa__background-animation",
  "starfield": "starfield-background-module-scss-module__KawuOa__starfield",
  "starfield-animation": "starfield-background-module-scss-module__KawuOa__starfield-animation",
});
